export default "__VITE_ASSET__BqMxAgcm__"